import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { AdminModeBanner } from './AdminModeBanner'

export function PageLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="min-h-dvh bg-background">
      <Header onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)} />

      {/* Desktop Sidebar */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileMenuOpen && (
        <div className="lg:hidden">
          <div
            className="fixed inset-0 z-30 bg-black/50"
            onClick={() => setMobileMenuOpen(false)}
          />
          <Sidebar />
        </div>
      )}

      {/* Main Content */}
      <main className="min-h-[calc(100dvh-3.5rem)] pt-14 lg:pl-[84px]">
        {/* AdminModeBanner sits inside the main content column so it
            aligns with the sidebar offset and the impersonation/
            superadmin warning is impossible to miss when present.
            Renders nothing in the common (non-escalated) case — see
            its body for the collapse-to-null behavior. */}
        <AdminModeBanner />
        <div className="container mx-auto p-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
